import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M997.35716,948.306842 C997.35716,948.193981 997.244298,948.081119 997.244298,947.968258 L997.35716,948.306842 Z M136.901011,505.212556 L449.753115,1749.28498 L661.029861,1696.1272 L448.285916,850.23019 L628.300024,804.859864 L1001.42017,1610.46532 L1231.43193,1552.56736 L1178.95133,666.378791 L1359.19116,621.008465 L1571.9351,1467.01834 L1783.09899,1413.86057 L1470.13402,169.78815 L1008.30473,286.035504 L1034.60146,962.978838 C1036.06866,998.191629 1013.38349,1028.88996 979.41218,1037.35457 C945.553727,1045.70632 911.130966,1029.45427 895.894663,997.51446 L598.84317,389.078063 L136.901011,505.212556 Z M367.81566,1886.18599 L0,423.2751 L660.126969,257.255819 L914.516812,778.45027 L891.831648,198.906419 L1552.18434,33 L1920,1495.79802 L1489.88479,1603.91935 L1303.6633,863.209264 L1349.59793,1639.245 L938.443452,1742.73901 L611.59652,1037.24171 L797.818011,1778.06466 L367.81566,1886.18599 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMatureLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMatureLine, _Component);

  var _super = _createSuper(IconMatureLine);

  function IconMatureLine() {
    _classCallCheck(this, IconMatureLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMatureLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMature",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMatureLine.displayName = "IconMatureLine";
  return IconMatureLine;
}(Component);

IconMatureLine.glyphName = 'mature';
IconMatureLine.variant = 'Line';
IconMatureLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMatureLine;
export { IconMatureLine };